// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"294":"c74c740f","377":"a9f7f59c","563":"b1d4c034","882":"7f47f9be","914":"0592c20b","967":"0592c20b"}[chunkId] + ".chunk.css";
};